// Add your JS customizations here
(function(jq) {
    jq(function() {  
        jq('section.feature-block, .expand-link').each(function(index){
            var link = this.dataset.link;
            var cssClass = this.dataset.linkcss;
            if (link) {
                var atag = jq(".card-link", this).clone();
                var target = atag.attr('target');
                $(this).wrapInner("<a href=" + link + " class='text-reset text-decoration-none " + cssClass + "' target='" + target + "'></a>");
            }
        });
    })
})(jQuery);


  // Helper: find the nearest scrollable ancestor you care about
  function getScrollContainer(el) {
    return el.closest('.offcanvas-body') ||
           el.closest('.offcanvas') ||
           document.scrollingElement; // window/page fallback
  }

  // Helper: get header offset inside offcanvas (so the toggle sits below the header)
  function getHeaderOffset(toggle) {
    const offcanvas = toggle.closest('.offcanvas');
    const header = offcanvas ? offcanvas.querySelector('.offcanvas-header') : null;
    return header ? header.offsetHeight : 0;
  }

  function scrollToggleToTop(toggle, behavior = 'smooth') {
    const container = getScrollContainer(toggle);
    const headerOffset = getHeaderOffset(toggle);

    const toggleRect = toggle.getBoundingClientRect();
    const containerRect =
      container === document.scrollingElement
        ? { top: 0 } // window viewport top
        : container.getBoundingClientRect();

    // Distance from container's visible top to the toggle
    const deltaTop =
      (toggleRect.top - containerRect.top) - headerOffset;

    // Compute the new scrollTop
    if (container === document.scrollingElement) {
      const target = window.pageYOffset + deltaTop;
      window.scrollTo({ top: target, behavior });
    } else {
      const target = container.scrollTop + deltaTop;
      container.scrollTo({ top: target, behavior });
    }
  }

  // When a dropdown is shown, Bootstrap fires on the .dropdown element
  // e.relatedTarget is the actual toggle <a> or <button>
  document.addEventListener('shown.bs.dropdown', (e) => {
    const toggle = e.relatedTarget || e.target.querySelector('[data-bs-toggle="dropdown"]');
    if (!toggle) return;

    // Defer to let layout settle (avoids minor jumps on some browsers)
    requestAnimationFrame(() => scrollToggleToTop(toggle, 'smooth'));
  });

  // Optional: when the offcanvas opens, ensure the *initial* focused element is visible
  document.addEventListener('shown.bs.offcanvas', (e) => {
    const offcanvas = e.target;
    const focusEl =
      offcanvas.querySelector('[data-autofocus]') ||
      offcanvas.querySelector('.dropdown-toggle') ||
      offcanvas.querySelector('a, button, [tabindex]:not([tabindex="-1"])');

    if (focusEl) {
      requestAnimationFrame(() => scrollToggleToTop(focusEl, 'auto'));
    }
  });

